<template>
    <div v-if="show" style="display:none">
        <a-button @click="modals.list=true"><a-icon type="edit" />日期标注</a-button>
        <ListMark :id="id" v-model="modals.list"/>
    </div>
</template>

<script>
import { Modal, Form, Input, Checkbox, DatePicker } from 'ant-design-vue';
import Vue from 'vue'
Vue.use(Modal)
Vue.use(Form)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(DatePicker)

import ListMark from '@/components/manage/mark/list'
export default {
    props: ['id', 'chart', 'table'],
    components: {
        ListMark,
    },
    computed: {
        show() {
            if((this.$store.state.game.info.mark===true || this.$store.state.game.info.admin===true)) {
                if(this.chart) {
                    if(this.chart.mark===false) {
                        return false
                    }
                    if(this.chart.mark===true) {
                        return true
                    }
                    // 暂时注释，目前测试阶段仅支持实时新增标注
                    if(['pie', 'pyramid', 'box', 'candle', 'heatmap', 'worldmap', 'chinamap', 'cloud', 'violin'].indexOf(this.chart.type)<0) {
                        if(this.chart.x && this.chart.x.id && ['ds', 'dt', 'date', 'date_id', 'time'].indexOf(this.chart.x.id)>=0) {
                            return true
                        }
                    }
                }
                if(this.table) {
                    return true
                }
            }
            return false
        }
    },
    data() {
        return {
            modals: {
                list: false,
            }
        }
    },
}
</script>

<style lang="less">
.manage_modal {
    .ant-modal-body {
        padding:10px 24px;
    }
    .ant-modal-title {
        font-weight: bold;
        color: #555;
        text-align: left;
        font-size:14px;
    }
    .ant-form-item {
        margin: 1em 0;
    }
    .ant-modal-footer {
    text-align: center;
    }
}

.mark_manage_model {
    .ant-modal-body {
        padding:10px 0;
        height: 320px;
        overflow: auto;
    }
    .ant-form-item-control {
        width:300px;
    }
    .is_all_item {
        .ant-form-item-label label:after {
            content: ' '
        }
    }
    .mark_list {
        margin:0 0 15px 0;
        padding:0 24px 15px 24px; 
        border-bottom:1px solid #ddd;
        display:flex;    
        justify-content: space-between;
        align-items: center;
        &:nth-last-child(1) {
            margin:0;
        }
        .mark_list_list {
            width:300px;
            margin:0;
        }
        .mark_btns {
            .ant-btn {
                margin:0 0 0 10px;
            }
        }
    }
}
</style>